<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Claim-Pets-Create",
  path: "create",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
